import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  CircularProgress,
  IconButton,
  Modal,
  Button,
  Paper,
  TextField,
  Stack,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { fetchCompanies , updateCompany } from "../../../services/jobService";
import {
  CustomTableContainer,
  CustomTableHead,
} from "../../../components/TableComponent";
import { useDispatch } from "react-redux";
import { showAppAlert } from "../../../store/reducers/appreducer";
const Companies = () => {
    const dispatch = useDispatch();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState({ open: false, company: null });
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    admin_email: "",
    email_domain: "",
  });
  const [updating, setUpdating] = useState(false);
  const getCompanies = async () => {
    try {
      setLoading(true);
      const response = await fetchCompanies();
      setCompanies(response.companies);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching companies:", error);
    dispatch(
      showAppAlert({
        show: true,
        alertType: "error",
        alertMessage: "Failed to fetch companies. Please try again.",
      })
    );
      setLoading(false);
    }
  };
    useEffect(() => {
    getCompanies();
  }, []);
  
  const handleEdit = (company) => {
    setFormData({
      name: company.name || "",
      phone: company.phone || "",
      admin_email: company.admin_email || "",
      email_domain: company.email_domain || "",
    });
    setEditModal({ open: true, company });
  };

  const closeModal = () => {
    setEditModal({ open: false, company: null });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setUpdating(true);
      const response = await updateCompany(editModal.company.id, formData);
      if(!response.error){ 
      setUpdating(false);
      dispatch(
        showAppAlert({
          show: true,
          alertType: "success",
          alertMessage: "Company updated successfully.",
        })
      );
    }else{
        setUpdating(false);
        dispatch(
            showAppAlert({
            show: true,
            alertType: "error",
            alertMessage: response.error,
            })
        );
    }
    } catch (error) {
      console.error("Error updating company:", error);
      setUpdating(false);
    }finally{
      closeModal();
      getCompanies();
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          height: "80vh", // Adjust height as needed
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
        <Typography variant="body1" mt={2}>
          Loading companies...
        </Typography>
      </Box>
    );
  }
  
  return (
    <Box
      sx={{
        border: "1px solid rgba(0, 0, 0, 0.2)",
        borderRadius: "30px",
        background: "#FFFFFF",
        boxShadow: "6px 6px 54px 0px #0000000D",
        padding: "20px",
      }}
    >
      <Box p={2}>
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontFamily: "Montserrat",
            fontWeight: 700,
            color: "#202224",
            opacity: 0.8,
          }}
        >
          Company Profiles
        </Typography>
      </Box>

      <Box
        sx={{
          borderRadius: "16px",
          border: "1px solid rgba(0, 0, 0, 0.2)",
          overflow: "hidden",
          backgroundColor: "#fff",
          margin: "4px 0",
        }}
      >
        <CustomTableContainer component={Paper}>
          <Table>
            <CustomTableHead>
              <TableRow>
                <TableCell align="center">Name</TableCell>
                <TableCell align="center">Phone</TableCell>
                <TableCell align="center">Admin Email</TableCell>
                <TableCell align="center">Email Domain</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </CustomTableHead>
            <TableBody>
              {companies.map((company) => (
                <TableRow key={company.id}>
                  <TableCell align="center">{company.name || "N/A"}</TableCell>
                  <TableCell align="center">{company.phone || "N/A"}</TableCell>
                  <TableCell align="center">{company.admin_email || "N/A"}</TableCell>
                  <TableCell align="center">{company.email_domain}</TableCell>
                  <TableCell align="center">
                    <IconButton color="primary" onClick={() => handleEdit(company)}>
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CustomTableContainer>
      </Box>

      {/* Edit Modal */}
      <Modal open={editModal.open} onClose={closeModal}>
        <Box
          p={4}
          bgcolor="white"
          borderRadius={2}
          boxShadow={3}
          maxWidth="500px"
          mx="auto"
          mt="15%"
        >
          <Typography variant="h6" gutterBottom>
            Edit Company
          </Typography>
          
          <form onSubmit={handleSubmit}>
            <Stack spacing={2} mt={2}>
              <TextField
                fullWidth
                label="Company Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Admin Email"
                name="admin_email"
                type="email"
                value={formData.admin_email}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Email Domain"
                name="email_domain"
                value={formData.email_domain}
                onChange={handleChange}
              />
              
              <Box textAlign="right" mt={2} display="flex" justifyContent="space-between">
                <Button variant="outlined" onClick={closeModal}>
                  Cancel
                </Button>
                <Button 
                  variant="contained" 
                  type="submit"
                  disabled={updating}
                >
                  {updating ? "Updating..." : "Save Changes"}
                </Button>
              </Box>
            </Stack>
          </form>
        </Box>
      </Modal>
    </Box>
  );
};

export default Companies;